import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Image, Card, Form, Badge, Accordion, Modal, Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaWhatsapp, FaPhone, FaPhoneAlt, FaEnvelope, FaEye, FaRegHeart, FaShareAlt, FaHeart , FaVideo} from "react-icons/fa";
import Navbar from "../../Pages/Navbar/EmployerNavbar";
import { useNavigate } from 'react-router-dom';
import BaseUrl from '../../ApiServices/BaseUrl';
import EmployerNavbar from '../../Pages/Navbar/EmployerNavbar';
import moment from 'moment';
import AgencyNavbar from '../../Pages/Navbar/AgencyNavbar';
import Footer from '../../Footer/Footer';
import Swal from 'sweetalert2';
import AgencyReportCandidate from './AgencyReportCandidate';
import '../ViewCandidates/ViewCandidates.css';
import '../../Home/Candidates/Candidates.css';
import './AgencyAppliedCandidates.css';
import { getVisibleOfferBadgeText, getVisibleSourceLabel, hasHighlightedSourceLabel, hasVisibleOfferBadge } from '../../../utils/candidateBadges';

function AgencyAppliedCandidates() {

    const [candidates, setCandidates] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [filteredCandidates, setFilteredCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [showMoreJobPosition, setShowMoreJobPosition] = useState(false);
    const [showMoreJobType, setShowMoreJobType] = useState(false);
    const [showMoreLanguage, setShowMoreLanguage] = useState(false);
    const [showMoreMainSkills, setShowMoreMainSkills] = useState(false);
    const [showFiltersMobile, setShowFiltersMobile] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const user = JSON.parse(localStorage.getItem("user")) || {};
    const userId = user.id || '';
    console.log("Current logged-in user ID:", userId);

    // Modal states
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [messageContent, setMessageContent] = useState("I'm interested");
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [showReportModal, setShowReportModal] = useState(false);
    const [selectedCandidateForReport, setSelectedCandidateForReport] = useState(null);
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareContent, setShareContent] = useState('');
    const [shareUrl, setShareUrl] = useState('');
    const [showLocation, setShowLocation] = useState(false);
    const [showContractStatus, setShowContractStatus] = useState(false);
    const [showPostedBy, setShowPostedBy] = useState(false);
    const [showStartDate, setShowStartDate] = useState(false);

    // Shortlist state
    const [shortlistedCandidates, setShortlistedCandidates] = useState({});

    // Add activeTab state
    const [activeTab, setActiveTab] = useState('applied'); // 'applied' or 'shortlisted'

    // Get agency info
    const agencyId = user.id || '';

    // Get shortlisted candidates list
    const shortlistedCandidatesList = candidates.filter(candidate =>
        shortlistedCandidates[candidate.user_id]
    );

    // Get not shortlisted candidates list
    const notShortlistedCandidatesList = candidates.filter(candidate =>
        !shortlistedCandidates[candidate.user_id]
    );

    // Filter states (rest of the filter states remain the same)
    const [jobPosition, setJobPosition] = useState({
        maid: false,
        driver: false,
        cook: false,
        nanny: false,
        nurse: false,
        houseboy: false,
        tailor: false,
        teacher: false,
        trainer: false,
        gardener: false,
        butler: false,
        housekeeper: false,
        laundryWorker: false,
        personalAssistant: false,
        caregiver: false,
        elderCareCompanion: false,
        petSitter: false,
        houseManager: false,
        cleaner: false,
        maintenanceWorker: false,
        babySitter: false,
        tutor: false,
        chauffeur: false,
        housemaid: false,
        kitchenStaff: false,
        diningRoomAttendant: false,
        personalChef: false,
        eventCoordinator: false,
        householdAdministrator: false,
        domesticAssistant: false
    });

    // ... (keep all other filter states as they are)
    const [candidateLocation, setCandidateLocation] = useState({
        india: false,
        bangladesh: false,
        nepal: false,
        sriLanka: false,
        pakistan: false,
        philippines: false,
        indonesia: false,
        myanmar: false,
        vietnam: false,
        cambodia: false,
        thailand: false,
        ethiopia: false,
        kenya: false,
        uganda: false,
        tanzania: false,
        rwanda: false,
        ghana: false,
        nigeria: false,
        sierraLeone: false,
        burundi: false
    });
    const [jobType, setJobType] = useState({
        fullTime: false,
        partTime: false,
        liveIn: false,
        liveOut: false,
        temporary: false,
        permanent: false,
        internship: false,
        contractual: false,
        freelance: false,
        volunteer: false,
        fresher: false
    });
    const [contractStatus, setContractStatus] = useState({
        permanent: false,
        temporary: false,
        contract: false
    });
    const [postedBy, setPostedBy] = useState({
        agency: false,
        directEmployer: false
    });
    const [language, setLanguage] = useState({
        english: false,
        mandarin: false,
        arabic: false,
        hindi: false,
        tagalog: false,
        cantonese: false,
        malay: false,
        tamil: false
    });
    const [mainSkills, setMainSkills] = useState({
        childcare: false,
        elderlyCare: false,
        cooking: false,
        cleaning: false,
        laundry: false,
        ironing: false,
        petCare: false,
        gardening: false
    });
    const [startDate, setStartDate] = useState('');

    const getSafeString = (value, fallback = '') => {
        if (value === null || value === undefined) return fallback;
        const str = String(value).trim();
        return str || fallback;
    };

    const getDisplayValue = (value, fallback = 'N/A') => {
        if (value === null || value === undefined || value === '') return fallback;
        if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : fallback;
        if (typeof value === 'string') {
            try {
                const parsed = JSON.parse(value.replace(/\\"/g, '"'));
                return Array.isArray(parsed) && parsed.length > 0 ? parsed.join(', ') : (value || fallback);
            } catch {
                return value || fallback;
            }
        }
        return value.toString() || fallback;
    };

    const parseToArray = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) return val;
        if (typeof val === 'string') {
            try {
                const parsed = JSON.parse(val.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [parsed];
            } catch {
                return [val];
            }
        }
        return [val];
    };

    const getCandidateExperienceYears = (profile) => {
        const exp =
            profile?.total_work_experience ||
            profile?.experience_years ||
            profile?.work_experience ||
            profile?.years_of_experience ||
            profile?.total_experience ||
            profile?.total_years_experience ||
            profile?.years_experience ||
            profile?.dtr_years_of_experience_doctor;
        if (typeof exp === 'number') return `${exp} years`;
        return getSafeString(exp, null) || null;
    };

    const getCountriesWorkedFromExperience = (profile) => {
        const expItems = parseToArray(profile?.experience);
        if (!expItems.length) return '';
        const countries = new Set();
        expItems.forEach((exp) => {
            if (!exp || typeof exp !== 'object') return;
            const possible = [
                exp.country,
                exp.work_country,
                exp.employer_country,
                exp.country_name,
                exp.country_experience,
                exp.previous_hospital_country
            ];
            possible.forEach((val) => {
                parseToArray(val).forEach((c) => {
                    const trimmed = getSafeString(c, '');
                    if (trimmed) countries.add(trimmed);
                });
            });
        });
        return countries.size ? Array.from(countries).join(', ') : '';
    };

    const buildCandidateEmailHTML = (candidate, message) => {
        const firstName = getSafeString(candidate?.first_name, '');
        const lastName = getSafeString(candidate?.last_name, '');
        const candidateName = [firstName, lastName].filter(Boolean).join(' ')
            || getSafeString(candidate?.full_name || candidate?.name, 'N/A');
        const categoryRaw = getDisplayValue(
            candidate?.category ||
            candidate?.job_category ||
            candidate?.domestic_worker_category ||
            candidate?.worker_category ||
            candidate?.candidate_category
        );
        const category = categoryRaw === 'N/A'
            ? getDisplayValue(candidate?.job_position || candidate?.position || candidate?.job_title)
            : categoryRaw;
        const experience = getDisplayValue(getCandidateExperienceYears(candidate) ||
            (parseToArray(candidate?.experience).length ? `${parseToArray(candidate.experience).length} previous roles` : null));
        const currentLocation = getDisplayValue(
            candidate?.current_country ||
            candidate?.current_location ||
            candidate?.current_city ||
            candidate?.city ||
            candidate?.country
        );
        const previousExperience = getDisplayValue(
            candidate?.gulf_europe_experience ||
            candidate?.overseas_experience ||
            candidate?.driving_country_experience ||
            candidate?.candidates_country_experience ||
            getCountriesWorkedFromExperience(candidate)
        );
        const baseCurrency = String(candidate?.expected_monthly_salary_currency || '').split(' | ')[0].trim();
        const expectedSalaryRaw =
            (baseCurrency && candidate?.expected_monthly_salary
                ? `${baseCurrency} ${candidate.expected_monthly_salary}`
                : candidate?.expected_monthly_salary_usd
                    ? `USD ${candidate.expected_monthly_salary_usd}`
                    : candidate?.expected_monthly_salary_qar
                        ? `QAR ${candidate.expected_monthly_salary_qar}`
                        : candidate?.expected_monthly_salary_omr
                            ? `OMR ${candidate.expected_monthly_salary_omr}`
                            : candidate?.expected_monthly_salary);
        const expectedSalary = getDisplayValue(expectedSalaryRaw);
        const availabilityRaw =
            candidate?.preferred_start_date === 'Immediate'
                ? 'Immediate'
                : (candidate?.preferred_start_date || candidate?.notice_period || candidate?.availability);
        const availability = getDisplayValue(availabilityRaw);
        const messageHtml = getSafeString(message, '').replace(/\n/g, '<br/>');

        return `
        <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #2c3e50; background-color: #ffffff;">
          <div style="font-size: 18px; font-weight: 700; padding-bottom: 8px; border-bottom: 2px solid #2f86eb;">
            Job Application Interest
          </div>

          <div style="margin: 18px 0 16px 0; padding: 14px 16px; background-color: #f6f8fb; border-left: 4px solid #2f86eb;">
            <div style="font-weight: 700; margin-bottom: 6px;">Message:</div>
            <div style="margin-bottom: 10px; color: #3f4a56;">${messageHtml || 'N/A'}</div>
            <ul style="margin: 8px 0 0 18px; padding: 0; color: #334155;">
              <li><strong>Category:</strong> ${category}</li>
              <li><strong>Total Experience:</strong> ${experience}</li>
              <li><strong>Current Location:</strong> ${currentLocation}</li>
              <li><strong>Previous Gulf/Europe Experience:</strong> ${previousExperience}</li>
              <li><strong>Expected Salary:</strong> ${expectedSalary}</li>
              <li><strong>Notice Period / Availability:</strong> ${availability}</li>
            </ul>
          </div>

          <div style="font-size: 16px; font-weight: 700; margin: 18px 0 8px 0;">Profile Details:</div>
          <table style="width: 100%; border-collapse: collapse; margin: 8px 0 16px 0;">
            <tr>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; width: 160px; background-color: #f8fafc;">Name:</td>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${candidateName}</td>
            </tr>
            <tr>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; background-color: #f8fafc;">Category:</td>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${category}</td>
            </tr>
            <tr>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; background-color: #f8fafc;">Experience:</td>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${experience}</td>
            </tr>
            <tr>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; background-color: #f8fafc;">Current Location:</td>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${currentLocation}</td>
            </tr>
          </table>

          <div style="margin-top: 16px; font-size: 12px; color: #7f8c8d;">
            This is an automated message from Gulf Worker job portal.
          </div>
        </div>
      `;
    };
    const [showMoreLocations, setShowMoreLocations] = useState(false);

    // ... (keep all handler functions as they are)
    const handleJobPositionChange = (e) => {
        const { name, checked } = e.target;
        setJobPosition(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const resetAllFilters = () => {
        setJobPosition({
            maid: false,
            driver: false,
            cook: false,
            nanny: false,
            nurse: false,
            houseboy: false,
            tailor: false,
            teacher: false,
            trainer: false,
            gardener: false,
            butler: false,
            housekeeper: false,
            laundryWorker: false,
            personalAssistant: false,
            caregiver: false,
            elderCareCompanion: false,
            petSitter: false,
            houseManager: false,
            cleaner: false,
            maintenanceWorker: false,
            babySitter: false,
            tutor: false,
            chauffeur: false,
            housemaid: false,
            kitchenStaff: false,
            diningRoomAttendant: false,
            personalChef: false,
            eventCoordinator: false,
            householdAdministrator: false,
            domesticAssistant: false
        });
        setCandidateLocation({
            india: false,
            bangladesh: false,
            nepal: false,
            sriLanka: false,
            pakistan: false,
            philippines: false,
            indonesia: false,
            myanmar: false,
            vietnam: false,
            cambodia: false,
            thailand: false,
            ethiopia: false,
            kenya: false,
            uganda: false,
            tanzania: false,
            rwanda: false,
            ghana: false,
            nigeria: false,
            sierraLeone: false,
            burundi: false
        });

        setJobType({
            fullTime: false,
            partTime: false,
            liveIn: false,
            liveOut: false,
            temporary: false,
            permanent: false,
            internship: false,
            contractual: false,
            freelance: false,
            volunteer: false,
            fresher: false
        });
        setContractStatus({
            permanent: false,
            temporary: false,
            contract: false
        });
        setPostedBy({
            agency: false,
            directEmployer: false
        });
        setLanguage({
            english: false,
            mandarin: false,
            arabic: false,
            hindi: false,
            tagalog: false,
            cantonese: false,
            malay: false,
            tamil: false
        });
        setMainSkills({
            childcare: false,
            elderlyCare: false,
            cooking: false,
            cleaning: false,
            laundry: false,
            ironing: false,
            petCare: false,
            gardening: false
        });
        setStartDate('');
    };

    const handleCandidateLocationChange = (e) => {
        const { name, checked } = e.target;
        setCandidateLocation(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleJobTypeChange = (e) => {
        const { name, checked } = e.target;
        setJobType(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleContractStatusChange = (e) => {
        const { name, checked } = e.target;
        setContractStatus(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handlePostedByChange = (e) => {
        const { name, checked } = e.target;
        setPostedBy(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleLanguageChange = (e) => {
        const { name, checked } = e.target;
        setLanguage(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleMainSkillsChange = (e) => {
        const { name, checked } = e.target;
        setMainSkills(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const toggleMoreLocations = () => {
        setShowMoreLocations(!showMoreLocations);
    };

    const handleViewClick = (userId) => {
        navigate(`/agencyappliedcandidatesview/${userId}`);
    };

    const handlePositionClick = (candidate) => {
        if (!candidate?.job_id) {
            navigate('/a-jobposting');
            return;
        }

        const selectedJob = jobs.find(job => Number(job.id) === Number(candidate.job_id));
        if (selectedJob) {
            navigate('/a-viewjobdetails', { state: { job: selectedJob } });
            return;
        }

        navigate('/a-jobposting');
    };

    // Helper function to format dates correctly
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        try {
            const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch (e) {
            console.error('Error formatting date:', e);
            return 'N/A';
        }
    };

    // Update screen width on resize
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = screenWidth < 768; // Mobile breakpoint

    // Helper function to safely parse array fields
    const safeParseArray = (field) => {
        if (Array.isArray(field)) return field;
        if (typeof field === 'string') {
            try {
                const parsed = JSON.parse(field.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    // ... (keep all other handler functions: handleShortlistClick, handleShareClick, handleMessageClick, etc.)
    const handleShortlistClick = async (candidate) => {
        const candidateUserId = candidate.user_id;
        const isCurrentlyShortlisted = shortlistedCandidates[candidateUserId];

        try {
            Swal.fire({
                title: isCurrentlyShortlisted ? 'Removing from shortlist...' : 'Adding to shortlist...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            if (isCurrentlyShortlisted) {
                const shortlistEntryId = shortlistedCandidates[candidateUserId];
                const response = await fetch(`${BaseUrl}/shortlist/${shortlistEntryId}`, {
                    method: 'DELETE',
                });

                if (!response.ok) {
                    throw new Error('Failed to remove candidate from shortlist');
                }

                setShortlistedCandidates(prev => {
                    const newState = { ...prev };
                    delete newState[candidateUserId];
                    return newState;
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Removed!',
                    text: 'Candidate removed from shortlist successfully!',
                    confirmButtonText: 'OK',
                });
            } else {
                const shortlistData = {
                    user_id: candidateUserId,
                    employer_id: agencyId,
                    employer_source: "Agency",
                    first_name: candidate.first_name?.split('@')[0] || candidate.first_name || 'Candidate',
                    email_id: candidate.email_id || candidate.email || ''
                };

                const response = await fetch(`${BaseUrl}/shortlist`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(shortlistData)
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || 'Failed to add candidate to shortlist');
                }

                setShortlistedCandidates(prev => ({
                    ...prev,
                    [candidateUserId]: data.data.id
                }));

                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Candidate added to shortlist successfully!',
                    confirmButtonText: 'OK',
                });
            }
        } catch (error) {
            console.error('Error toggling shortlist:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: error.message || 'An error occurred. Please try again.',
            });
        }
    };

    const handleShareClick = (candidate) => {
        const candidateName = candidate.first_name?.split('@')[0] || 'Candidate';
        const candidateAge = candidate.age ? `${candidate.age} years` : '';
        const nationality = candidate.nationality || '';

        const jobPosition = Array.isArray(candidate.job_position)
            ? candidate.job_position.join(', ')
            : candidate.job_position || 'Domestic Worker';

        const experience = candidate.total_work_experience || 'Not specified';
        const currentLocation = candidate.current_country || 'Not specified';

        const shareText = `Check out ${candidateName}'s profile - ${jobPosition} | ${nationality} | ${candidateAge} | ${experience} experience | Currently in ${currentLocation}. Find more candidates on Gulf Worker.`;
        const shareUrl = `${window.location.origin}/candidateview/${candidate.user_id}`;
        const fullShareContent = `${shareText} ${shareUrl}`;

        if (navigator.share) {
            navigator.share({
                title: `${candidateName} - ${jobPosition}`,
                text: shareText,
                url: shareUrl,
            }).catch((error) => console.log('Error sharing:', error));
        } else {
            setSelectedCandidate(candidate);
            setShareContent(fullShareContent);
            setShareUrl(shareUrl);
            setShowShareModal(true);
        }
    };

    const handleMessageClick = (candidate) => {
        setSelectedCandidate(candidate);
        setShowMessageModal(true);
    };

    const handleCloseMessageModal = () => {
        setShowMessageModal(false);
        setMessageContent('');
        setSelectedCandidate(null);
    };

    const handleSendMessage = async () => {
        if (!messageContent.trim() || !selectedCandidate) {
            Swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: 'Please enter a message',
            });
            return;
        }

        try {
            Swal.fire({
                title: 'Sending message...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const storeResponse = await fetch(`${BaseUrl}/message`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    emp_id: agencyId,
                    job_seeker_id: selectedCandidate.user_id,
                    message: messageContent
                })
            });

            const storeData = await storeResponse.json();

            if (!storeResponse.ok) {
                throw new Error(storeData.message || 'Failed to store message');
            }

            const emailMessageHTML = buildCandidateEmailHTML(selectedCandidate, messageContent);
            const emailResponse = await fetch(`${BaseUrl}/api/send-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    to_email: selectedCandidate.email_id,
                    subject: `Message regarding your application`,
                    message: emailMessageHTML
                })
            });

            const emailData = await emailResponse.json();

            if (!emailResponse.ok) {
                throw new Error(emailData.message || 'Failed to send email');
            }

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Message sent successfully!',
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                handleCloseMessageModal();
                setMessageContent("I'm interested");
            });

        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: error.message || 'An error occurred. Please try again.',
            });
        }
    };

    const handleReportClick = (candidate) => {
        setSelectedCandidateForReport(candidate);
        setShowReportModal(true);
    };

    const shareViaWhatsApp = (text) => {
        const encodedText = encodeURIComponent(text);
        window.open(`https://wa.me/?text=${encodedText}`, '_blank');
    };

    const shareViaFacebook = (url) => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
    };

    const shareViaTwitter = (text) => {
        const encodedText = encodeURIComponent(text);
        window.open(`https://twitter.com/intent/tweet?text=${encodedText}`, '_blank');
    };

    const shareViaLinkedIn = (url) => {
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'Copied!',
                text: 'Link copied to clipboard',
                timer: 1500,
                showConfirmButton: false
            });
        });
    };

    // ... (keep all useEffect hooks as they are)
    useEffect(() => {
        const fetchShortlistedStatus = async () => {
            try {
                const response = await fetch(`${BaseUrl}/shortlist/employer/${agencyId}`);
                if (response.ok) {
                    const data = await response.json();
                    const shortlistedMap = {};
                    data.forEach(entry => {
                        shortlistedMap[entry.user_id] = entry.id;
                    });
                    setShortlistedCandidates(shortlistedMap);
                }
            } catch (error) {
                console.error('Error fetching shortlisted status:', error);
            }
        };

        if (agencyId) {
            fetchShortlistedStatus();
        }
    }, [agencyId]);

    useEffect(() => {
        const fetchCandidates = async () => {
            try {
                setLoading(true);
                // 1. Fetch all applications
                const appResponse = await fetch(`${BaseUrl}/api/applications`);
                if (!appResponse.ok) throw new Error('Failed to fetch applications');
                const applications = await appResponse.json();

                // 2. Fetch jobs posted by this agency
                const jobResponse = await fetch(`${BaseUrl}/api/employer/by-user?user_id=${userId}`);
                if (!jobResponse.ok) throw new Error('Failed to fetch agency jobs');
                const agencyJobs = await jobResponse.json();
                setJobs(agencyJobs);

                // 3. Filter applications for this agency
                const myApplications = applications.filter(app => app.empuserid === userId);

                // 4. Fetch all user data (for emails and whatsapp)
                const userResponse = await fetch(`${BaseUrl}/`);
                const allUsers = userResponse.ok ? await userResponse.json() : [];

                // 5. Fetch all job seekers
                const response = await fetch(`${BaseUrl}/api/job-seeker`);
                if (!response.ok) throw new Error('Failed to fetch candidates');
                const allJobSeekers = await response.json();

                // 5. Join data: Each row is an APPLICATION
                const combinedData = [];
                myApplications.forEach(app => {
                    const candidate = allJobSeekers.find(js => js.user_id === app.userid);
                    const job = agencyJobs.find(j => j.id === app.jobid);

                    if (candidate) {
                        const userData = allUsers.find(u => u.id === candidate.user_id);
                        combinedData.push({
                            ...candidate,
                            email: candidate.email || userData?.email || '',
                            whatsapp_number: candidate.whatsapp_number || userData?.whatsapp_number || userData?.mobile_number || '',
                            application_id: app.id,
                            application_date: app.application_date,
                            application_status: app.status,
                            job_title: job ? job.job_title : (job?.domestic_worker_category || 'N/A'),
                            job_id: app.jobid,
                            // Parsing arrays for card/filtering logic if still needed
                            language: safeParseArray(candidate.language),
                            main_skills: safeParseArray(candidate.main_skills),
                            preferred_countries: safeParseArray(candidate.preferred_countries),
                            work_experience: safeParseArray(candidate.work_experience),
                            job_position: safeParseArray(candidate.job_position),
                            profile_photo: candidate.profile_photo
                                ? `${BaseUrl}${candidate.profile_photo}`
                                : null
                        });
                    }
                });

                // Sort by application date descending
                combinedData.sort((a, b) => new Date(b.application_date) - new Date(a.application_date));

                setCandidates(combinedData);
                setFilteredCandidates(combinedData);
            } catch (err) {
                console.error("Error fetching data:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (userId) {
            fetchCandidates();
        }
    }, [userId]);

    useEffect(() => {
        let result = [...candidates];

        // ... (keep all filter logic as it is)
        if (Object.values(jobPosition).some(v => v)) {
            result = result.filter(candidate => {
                const jobPositions = Array.isArray(candidate.job_position)
                    ? candidate.job_position.map(pos => pos?.toLowerCase() || '')
                    : [candidate.job_position?.toLowerCase() || ''];

                const jobPositionsString = jobPositions.join(' ');

                return (
                    (jobPosition.maid && jobPositionsString.includes('maid')) ||
                    (jobPosition.driver && jobPositionsString.includes('driver')) ||
                    (jobPosition.cook && jobPositionsString.includes('cook')) ||
                    (jobPosition.nanny && jobPositionsString.includes('nanny')) ||
                    (jobPosition.nurse && jobPositionsString.includes('nurse')) ||
                    (jobPosition.houseboy && jobPositionsString.includes('houseboy')) ||
                    (jobPosition.tailor && jobPositionsString.includes('tailor')) ||
                    (jobPosition.teacher && jobPositionsString.includes('teacher')) ||
                    (jobPosition.trainer && jobPositionsString.includes('trainer')) ||
                    (jobPosition.gardener && jobPositionsString.includes('gardener')) ||
                    (jobPosition.butler && jobPositionsString.includes('butler')) ||
                    (jobPosition.housekeeper && jobPositionsString.includes('housekeeper')) ||
                    (jobPosition.laundryWorker && jobPositionsString.includes('laundry')) ||
                    (jobPosition.personalAssistant && jobPositionsString.includes('personal assistant')) ||
                    (jobPosition.caregiver && jobPositionsString.includes('caregiver')) ||
                    (jobPosition.elderCareCompanion && jobPositionsString.includes('elder care')) ||
                    (jobPosition.petSitter && (jobPositionsString.includes('pet') || jobPositionsString.includes('dog walker'))) ||
                    (jobPosition.houseManager && jobPositionsString.includes('house manager')) ||
                    (jobPosition.cleaner && jobPositionsString.includes('cleaner')) ||
                    (jobPosition.maintenanceWorker && (jobPositionsString.includes('maintenance') || jobPositionsString.includes('handyman'))) ||
                    (jobPosition.babySitter && jobPositionsString.includes('baby sitter')) ||
                    (jobPosition.tutor && jobPositionsString.includes('tutor')) ||
                    (jobPosition.chauffeur && jobPositionsString.includes('chauffeur')) ||
                    (jobPosition.housemaid && jobPositionsString.includes('housemaid')) ||
                    (jobPosition.kitchenStaff && jobPositionsString.includes('kitchen staff')) ||
                    (jobPosition.diningRoomAttendant && jobPositionsString.includes('dining room')) ||
                    (jobPosition.personalChef && jobPositionsString.includes('personal chef')) ||
                    (jobPosition.eventCoordinator && jobPositionsString.includes('event coordinator')) ||
                    (jobPosition.householdAdministrator && jobPositionsString.includes('household administrator')) ||
                    (jobPosition.domesticAssistant && jobPositionsString.includes('domestic assistant'))
                );
            });
        }

        const selectedLocations = [];
        if (candidateLocation.india) selectedLocations.push('india');
        if (candidateLocation.bangladesh) selectedLocations.push('bangladesh');
        if (candidateLocation.nepal) selectedLocations.push('nepal');
        if (candidateLocation.sriLanka) selectedLocations.push('sri lanka', 'sri lankan');
        if (candidateLocation.pakistan) selectedLocations.push('pakistan');
        if (candidateLocation.philippines) selectedLocations.push('philippines');
        if (candidateLocation.indonesia) selectedLocations.push('indonesia');
        if (candidateLocation.myanmar) selectedLocations.push('myanmar', 'burma');
        if (candidateLocation.vietnam) selectedLocations.push('vietnam');
        if (candidateLocation.cambodia) selectedLocations.push('cambodia');
        if (candidateLocation.thailand) selectedLocations.push('thailand');
        if (candidateLocation.ethiopia) selectedLocations.push('ethiopia');
        if (candidateLocation.kenya) selectedLocations.push('kenya');
        if (candidateLocation.uganda) selectedLocations.push('uganda');
        if (candidateLocation.tanzania) selectedLocations.push('tanzania');
        if (candidateLocation.rwanda) selectedLocations.push('rwanda');
        if (candidateLocation.ghana) selectedLocations.push('ghana');
        if (candidateLocation.nigeria) selectedLocations.push('nigeria');
        if (candidateLocation.sierraLeone) selectedLocations.push('sierra leone');
        if (candidateLocation.burundi) selectedLocations.push('burundi');


        if (selectedLocations.length > 0) {
            result = result.filter(candidate => {
                const nationality = candidate.nationality?.toLowerCase() || '';
                return selectedLocations.some(location => nationality.includes(location));
            });
        }

        if (
            jobType.fullTime || jobType.partTime || jobType.liveIn || jobType.liveOut ||
            jobType.temporary || jobType.permanent || jobType.internship || jobType.contractual ||
            jobType.freelance || jobType.volunteer || jobType.fresher
        ) {
            result = result.filter(candidate => {
                const type = candidate.job_type?.toLowerCase() || '';
                return (
                    (jobType.fullTime && type.includes('full time')) ||
                    (jobType.partTime && type.includes('part time')) ||
                    (jobType.liveIn && type.includes('live in')) ||
                    (jobType.liveOut && type.includes('live out')) ||
                    (jobType.temporary && type.includes('temporary')) ||
                    (jobType.permanent && type.includes('permanent')) ||
                    (jobType.internship && type.includes('internship')) ||
                    (jobType.contractual && type.includes('contractual')) ||
                    (jobType.freelance && type.includes('freelance')) ||
                    (jobType.volunteer && type.includes('volunteer')) ||
                    (jobType.fresher && type.includes('fresher'))
                );
            });
        }

        if (contractStatus.permanent || contractStatus.temporary || contractStatus.contract) {
            result = result.filter(candidate => {
                const status = candidate.visa_type?.toLowerCase();
                return (contractStatus.permanent && status?.includes('permanent')) ||
                    (contractStatus.temporary && status?.includes('temporary')) ||
                    (contractStatus.contract && status?.includes('contract'));
            });
        }

        if (postedBy.agency || postedBy.directEmployer) {
            result = result.filter(candidate => {
                const source = candidate.source?.toLowerCase();
                return (postedBy.agency && source?.includes('agency')) ||
                    (postedBy.directEmployer && source?.includes('direct'));
            });
        }

        if (
            language.english || language.mandarin || language.arabic || language.hindi ||
            language.tagalog || language.cantonese || language.malay || language.tamil
        ) {
            result = result.filter(candidate => {
                const langs = Array.isArray(candidate.language)
                    ? candidate.language.map(l => l.language?.toLowerCase() || l?.toLowerCase() || '').join(' ')
                    : (candidate.language?.toLowerCase() || '');

                return (
                    (language.english && langs.includes('english')) ||
                    (language.mandarin && langs.includes('mandarin')) ||
                    (language.arabic && langs.includes('arabic')) ||
                    (language.hindi && langs.includes('hindi')) ||
                    (language.tagalog && langs.includes('tagalog')) ||
                    (language.cantonese && langs.includes('cantonese')) ||
                    (language.malay && langs.includes('malay')) ||
                    (language.tamil && langs.includes('tamil'))
                );
            });
        }

        if (
            mainSkills.childcare || mainSkills.elderlyCare || mainSkills.cooking ||
            mainSkills.cleaning || mainSkills.laundry || mainSkills.ironing ||
            mainSkills.petCare || mainSkills.gardening
        ) {
            result = result.filter(candidate => {
                const skills = Array.isArray(candidate.main_skills)
                    ? candidate.main_skills.join(' ').toLowerCase()
                    : (candidate.main_skills?.toLowerCase() || '');

                return (
                    (mainSkills.childcare && skills.includes('childcare')) ||
                    (mainSkills.elderlyCare && skills.includes('elderly care')) ||
                    (mainSkills.cooking && skills.includes('cooking')) ||
                    (mainSkills.cleaning && skills.includes('cleaning')) ||
                    (mainSkills.laundry && skills.includes('laundry')) ||
                    (mainSkills.ironing && skills.includes('ironing')) ||
                    (mainSkills.petCare && skills.includes('pet care')) ||
                    (mainSkills.gardening && skills.includes('gardening'))
                );
            });
        }

        if (startDate) {
            try {
                const selectedDate = new Date(startDate);
                selectedDate.setHours(0, 0, 0, 0);

                result = result.filter(candidate => {
                    if (!candidate.preferred_start_date) return false;

                    try {
                        const candidateDate = new Date(candidate.preferred_start_date);
                        candidateDate.setHours(0, 0, 0, 0);
                        return candidateDate >= selectedDate;
                    } catch (e) {
                        console.error('Error parsing candidate date:', candidate.preferred_start_date, e);
                        return false;
                    }
                });
            } catch (e) {
                console.error('Error parsing selected date:', startDate, e);
            }
        }

        setFilteredCandidates(result);
    }, [
        candidates,
        jobPosition,
        candidateLocation,
        jobType,
        contractStatus,
        postedBy,
        language,
        mainSkills,
        startDate
    ]);

    if (loading) {
        return (
            <>
                <AgencyNavbar />
                <div className="text-center mt-5">Loading candidates...</div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <AgencyNavbar />
                <div className="text-center mt-5 text-danger">Error: {error}</div>
            </>
        );
    }

    const renderCandidateTable = (data, isShortlistedTab) => (
        <div className="table-responsive candidate-table-dashboard mt-3">
            <Table hover className="candidate-admin-table">
                <thead className="admin-table-header">
                    <tr>
                        <th className="text-center">S.No</th>
                        <th>Name</th>
                        <th className="text-center">Email</th>
                        <th className="text-center">Phone</th>
                        <th>Category</th>
                        <th>Position</th>
                        <th className="text-center">Age/Gender</th>
                        <th>Nationality</th>
                        <th>Current Country</th>
                        <th>Registered Date</th>
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((candidate, index) => (
                        <tr key={`${candidate.user_id}-${candidate.application_id || index}`}>
                            <td className="text-center align-middle">{index + 1}</td>
                            <td className="align-middle">
                                <div className="d-flex align-items-center gap-2">
                                    <Image
                                        src={candidate.profile_photo || 'https://via.placeholder.com/40'}
                                        roundedCircle
                                        width={32}
                                        height={32}
                                        className="candidate-avatar-mini"
                                    />
                                    <div className="candidate-info-cell">
                                        <div className="candidate-primary-name">{candidate.first_name || 'N/A'} {candidate.last_name || ''}</div>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center align-middle">
                                {candidate.email ? (
                                    <a href={`mailto:${candidate.email}`} title={candidate.email} className="contact-icon-btn email-btn">
                                        <FaEnvelope />
                                    </a>
                                ) : <span className="text-muted">-</span>}
                            </td>
                            <td className="text-center align-middle">
                                {candidate.whatsapp_number ? (
                                    <a href={`https://wa.me/${candidate.whatsapp_number}`} target="_blank" rel="noopener noreferrer" title={candidate.whatsapp_number} className="contact-icon-btn applied-phone-btn">
                                        <FaPhoneAlt className="applied-phone-icon" />
                                    </a>
                                ) : <span className="text-muted">-</span>}
                            </td>
                            <td className="align-middle">{candidate.candidate_category || candidate.job_position?.[0]?.name || candidate.job_position?.[0] || 'N/A'}</td>
                            <td className="align-middle">
                                <Button
                                    variant="link"
                                    className="p-0 text-start text-decoration-none position-text"
                                    onClick={() => handlePositionClick(candidate)}
                                    title={candidate.job_title}
                                    style={{ maxWidth: '220px' }}
                                >
                                    <div className="text-truncate">
                                        {candidate.job_title || 'N/A'}
                                    </div>
                                </Button>
                            </td>
                            <td className="text-center align-middle">{candidate.age || 'N/A'} / {candidate.gender || 'N/A'}</td>
                            <td className="align-middle">{candidate.nationality || 'N/A'}</td>
                            <td className="align-middle">{candidate.current_country || 'N/A'}</td>
                            <td className="align-middle">{candidate.application_date ? moment(candidate.application_date).format('DD MMM YYYY') : 'N/A'}</td>
                            <td className="align-middle">
                                <div className="d-flex gap-1 justify-content-center">
                                    <Button
                                        variant="outline-info"
                                        size="sm"
                                        className="admin-action-btn"
                                        onClick={() => handleViewClick(candidate.user_id)}
                                        title="View Details"
                                    >
                                        <FaEye />
                                    </Button>
                                    <Button
                                        variant={shortlistedCandidates[candidate.user_id] ? "danger" : "outline-success"}
                                        size="sm"
                                        className="admin-action-btn"
                                        onClick={() => handleShortlistClick(candidate)}
                                        title={shortlistedCandidates[candidate.user_id] ? "Remove from Shortlist" : "Shortlist"}
                                    >
                                        {shortlistedCandidates[candidate.user_id] ? <FaHeart /> : <FaRegHeart />}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );

    return (
        <>
            <AgencyNavbar />
            <Container fluid className="p-3">

                {/* Message Modal */}
                <Modal show={showMessageModal} onHide={handleCloseMessageModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Message {selectedCandidate?.first_name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="messageContent">
                            <Form.Label>Your Message</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                value={messageContent}
                                onChange={(e) => setMessageContent(e.target.value)}
                                placeholder={`Write your message to ${selectedCandidate?.first_name}...`}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseMessageModal}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleSendMessage}>
                            Send Message
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Share Modal */}
                <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Share Candidate Profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <p className="mb-4">Share this candidate profile via:</p>
                        <div className="d-flex justify-content-center gap-3 mb-4">
                            <Button variant="success" className="rounded-circle share-btn" onClick={() => shareViaWhatsApp(shareContent)}>
                                <i className="bi bi-whatsapp fs-4"></i>
                            </Button>
                            <Button variant="primary" className="rounded-circle share-btn" onClick={() => shareViaFacebook(shareUrl)}>
                                <i className="bi bi-facebook fs-4"></i>
                            </Button>
                            <Button variant="info" className="rounded-circle share-btn" onClick={() => shareViaTwitter(shareContent)}>
                                <i className="bi bi-twitter fs-4"></i>
                            </Button>
                            <Button variant="primary" style={{ backgroundColor: '#0077b5' }} className="rounded-circle share-btn" onClick={() => shareViaLinkedIn(shareUrl)}>
                                <i className="bi bi-linkedin fs-4"></i>
                            </Button>
                            <Button variant="secondary" className="rounded-circle share-btn" onClick={() => copyToClipboard(shareUrl)}>
                                <i className="bi bi-link-45deg fs-4"></i>
                            </Button>
                        </div>
                        <Form.Group>
                            <Form.Label>Share this text:</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={shareContent}
                                readOnly
                                onClick={(e) => e.target.select()}
                            />
                        </Form.Group>
                    </Modal.Body>
                </Modal>

                <Row style={{ marginTop: "75px" }}>
                    {isMobile && (
                        <div className="mb-3">
                            <button
                                className="btn btn-primary w-100"
                                onClick={() => setShowFiltersMobile(!showFiltersMobile)}
                            >
                                <i className={`bi ${showFiltersMobile ? 'bi-chevron-up' : 'bi-chevron-down'} me-2`}></i>
                                {showFiltersMobile ? 'Hide Filters' : 'Show Filters'}
                            </button>
                        </div>
                    )}
                    {/* Filter Section */}
                    {(showFiltersMobile || !isMobile) && (
                        <Col md={2}>
                            <div className="viewjobposting-filters p-3 border rounded bg-light">
                                {/* Filter Header with Refresh Button */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="mb-0">Filters</h5>
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={resetAllFilters}
                                        title="Reset all filters"
                                    >
                                        <i className="bi bi-arrow-clockwise"></i> Reset
                                    </button>
                                </div>

                                {/* Candidate Nationality Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowLocation(!showLocation)}
                                    >
                                        <strong>Candidate Nationality</strong>
                                        <i className={`bi ${showLocation ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showLocation && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'india', name: 'India' },
                                                { id: 'bangladesh', name: 'Bangladesh' },
                                                { id: 'nepal', name: 'Nepal' },
                                                { id: 'sriLanka', name: 'Sri Lanka' },
                                                { id: 'pakistan', name: 'Pakistan' },
                                                { id: 'philippines', name: 'Philippines' },
                                                { id: 'indonesia', name: 'Indonesia' },
                                                { id: 'myanmar', name: 'Myanmar' },
                                                { id: 'vietnam', name: 'Vietnam' },
                                                { id: 'cambodia', name: 'Cambodia' },
                                                { id: 'thailand', name: 'Thailand' },
                                                { id: 'ethiopia', name: 'Ethiopia' },
                                                { id: 'kenya', name: 'Kenya' },
                                                { id: 'uganda', name: 'Uganda' },
                                                { id: 'tanzania', name: 'Tanzania' },
                                                { id: 'rwanda', name: 'Rwanda' },
                                                { id: 'ghana', name: 'Ghana' },
                                                { id: 'nigeria', name: 'Nigeria' },
                                                { id: 'sierraLeone', name: 'Sierra Leone' },
                                                { id: 'burundi', name: 'Burundi' }
                                            ].slice(0, showMoreLocations ? 16 : 5).map((location) => (
                                                <div key={location.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`location-${location.id}`}
                                                        checked={candidateLocation[location.id]}
                                                        onChange={(e) => handleCandidateLocationChange({
                                                            target: {
                                                                name: location.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`location-${location.id}`}>
                                                        {location.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(candidateLocation).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                    onClick={toggleMoreLocations}
                                                >
                                                    {showMoreLocations ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Job Position Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                    >
                                        <strong>Job Position</strong>
                                        <i className={`bi ${showMoreJobPosition ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobPosition && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'maid', name: 'Maid' },
                                                { id: 'driver', name: 'Driver' },
                                                { id: 'cook', name: 'Cook' },
                                                { id: 'nanny', name: 'Nanny' },
                                                { id: 'nurse', name: 'Nurse' },
                                                { id: 'houseboy', name: 'Houseboy' },
                                                { id: 'tailor', name: 'Tailor' },
                                                { id: 'teacher', name: 'Teacher' },
                                                { id: 'trainer', name: 'Trainer' },
                                                { id: 'gardener', name: 'Gardener' },
                                                { id: 'butler', name: 'Butler' },
                                                { id: 'housekeeper', name: 'Housekeeper' },
                                                { id: 'laundryWorker', name: 'Laundry Worker' },
                                                { id: 'personalAssistant', name: 'Personal Assistant' },
                                                { id: 'caregiver', name: 'Caregiver' },
                                                { id: 'elderCareCompanion', name: 'Elder Care Companion' },
                                                { id: 'petSitter', name: 'Pet Sitter' },
                                                { id: 'houseManager', name: 'House Manager' },
                                                { id: 'cleaner', name: 'Cleaner' },
                                                { id: 'maintenanceWorker', name: 'Maintenance Worker' },
                                                { id: 'babySitter', name: 'Baby Sitter' },
                                                { id: 'tutor', name: 'Tutor' },
                                                { id: 'chauffeur', name: 'Chauffeur' },
                                                { id: 'housemaid', name: 'Housemaid' },
                                                { id: 'kitchenStaff', name: 'Kitchen Staff' },
                                                { id: 'diningRoomAttendant', name: 'Dining Room Attendant' },
                                                { id: 'personalChef', name: 'Personal Chef' },
                                                { id: 'eventCoordinator', name: 'Event Coordinator' },
                                                { id: 'householdAdministrator', name: 'Household Administrator' },
                                                { id: 'domesticAssistant', name: 'Domestic Assistant' }
                                            ].slice(0, showMoreJobPosition ? 30 : 5).map((position) => (
                                                <div key={position.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`position-${position.id}`}
                                                        checked={jobPosition[position.id]}
                                                        onChange={(e) => handleJobPositionChange({
                                                            target: {
                                                                name: position.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`position-${position.id}`}>
                                                        {position.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(jobPosition).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                    onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                                >
                                                    {showMoreJobPosition ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Job Type Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobType(!showMoreJobType)}
                                    >
                                        <strong>Job Type</strong>
                                        <i className={`bi ${showMoreJobType ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobType && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'fullTime', name: 'Full Time' },
                                                { id: 'partTime', name: 'Part Time' },
                                                { id: 'liveIn', name: 'Live In' },
                                                { id: 'liveOut', name: 'Live Out' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'internship', name: 'Internship' },
                                                { id: 'contractual', name: 'Contractual' },
                                                { id: 'freelance', name: 'Freelance' },
                                                { id: 'volunteer', name: 'Volunteer' },
                                                { id: 'fresher', name: 'Fresher' }
                                            ].slice(0, showMoreJobType ? 11 : 5).map((type) => (
                                                <div key={type.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`jobType-${type.id}`}
                                                        checked={jobType[type.id]}
                                                        onChange={(e) => handleJobTypeChange({
                                                            target: {
                                                                name: type.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`jobType-${type.id}`}>
                                                        {type.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(jobType).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                    onClick={() => setShowMoreJobType(!showMoreJobType)}
                                                >
                                                    {showMoreJobType ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Contract Status Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowContractStatus(!showContractStatus)}
                                    >
                                        <strong>Contract Status</strong>
                                        <i className={`bi ${showContractStatus ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showContractStatus && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'contract', name: 'Contract' }
                                            ].map((status) => (
                                                <div key={status.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`contract-${status.id}`}
                                                        checked={contractStatus[status.id]}
                                                        onChange={(e) => handleContractStatusChange({
                                                            target: {
                                                                name: status.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`contract-${status.id}`}>
                                                        {status.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Posted By Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowPostedBy(!showPostedBy)}
                                    >
                                        <strong>Post By</strong>
                                        <i className={`bi ${showPostedBy ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showPostedBy && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'agency', name: 'Agency' },
                                                { id: 'directEmployer', name: 'Direct Employer' }
                                            ].map((post) => (
                                                <div key={post.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`postedBy-${post.id}`}
                                                        checked={postedBy[post.id]}
                                                        onChange={(e) => handlePostedByChange({
                                                            target: {
                                                                name: post.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`postedBy-${post.id}`}>
                                                        {post.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Language Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                    >
                                        <strong>Language</strong>
                                        <i className={`bi ${showMoreLanguage ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreLanguage && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'english', name: 'English' },
                                                { id: 'mandarin', name: 'Mandarin' },
                                                { id: 'arabic', name: 'Arabic' },
                                                { id: 'hindi', name: 'Hindi' },
                                                { id: 'tagalog', name: 'Tagalog' },
                                                { id: 'cantonese', name: 'Cantonese' },
                                                { id: 'malay', name: 'Malay' },
                                                { id: 'tamil', name: 'Tamil' }
                                            ].slice(0, showMoreLanguage ? 8 : 5).map((lang) => (
                                                <div key={lang.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`language-${lang.id}`}
                                                        checked={language[lang.id]}
                                                        onChange={(e) => handleLanguageChange({
                                                            target: {
                                                                name: lang.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`language-${lang.id}`}>
                                                        {lang.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(language).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                    onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                                >
                                                    {showMoreLanguage ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Main Skills Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreMainSkills(!showMoreMainSkills)}
                                    >
                                        <strong>Main Skills</strong>
                                        <i className={`bi ${showMoreMainSkills ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreMainSkills && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'childcare', name: 'Childcare' },
                                                { id: 'elderlyCare', name: 'Elderly Care' },
                                                { id: 'cooking', name: 'Cooking' },
                                                { id: 'cleaning', name: 'Cleaning' },
                                                { id: 'laundry', name: 'Laundry' },
                                                { id: 'ironing', name: 'Ironing' },
                                                { id: 'petCare', name: 'Pet Care' },
                                                { id: 'gardening', name: 'Gardening' }
                                            ].map((skill) => (
                                                <div key={skill.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`skill-${skill.id}`}
                                                        checked={mainSkills[skill.id]}
                                                        onChange={(e) => handleMainSkillsChange({
                                                            target: {
                                                                name: skill.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`skill-${skill.id}`}>
                                                        {skill.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Start Date Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowStartDate(!showStartDate)}
                                    >
                                        <strong>Start Date</strong>
                                        <i className={`bi ${showStartDate ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showStartDate && (
                                        <div className="p-2 bg-white rounded border">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={startDate}
                                                onChange={handleStartDateChange}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    )}

                    {/* Candidates List */}
                    <Col md={10}>
                        {/* Add Tabs Section */}
                        <div className="mb-4">
                            <div className="d-flex border-bottom">
                                <Button
                                    variant="link"
                                    className={`text-decoration-none me-4 px-0 pb-2 border-0 rounded-0 ${activeTab === 'applied'
                                        ? 'text-primary border-bottom border-primary border-3'
                                        : 'text-muted'
                                        }`}
                                    onClick={() => setActiveTab('applied')}
                                >
                                    <h5 className="mb-0">Applicant ({filteredCandidates.length})</h5>
                                </Button>
                                <Button
                                    variant="link"
                                    className={`text-decoration-none px-0 pb-2 border-0 rounded-0 ${activeTab === 'shortlisted'
                                        ? 'text-primary border-bottom border-primary border-3'
                                        : 'text-muted'
                                        }`}
                                    onClick={() => setActiveTab('shortlisted')}
                                >
                                    <h5 className="mb-0">Shortlisted ({shortlistedCandidatesList.length})</h5>
                                </Button>
                            </div>
                        </div>

                        {/* Candidates Table based on active tab */}
                        {activeTab === 'applied' ? (
                            <>
                                {filteredCandidates.length === 0 ? (
                                    <div className="text-center no-jobs-message">No candidates match your filters</div>
                                ) : (
                                    renderCandidateTable(filteredCandidates, false)
                                )}
                            </>
                        ) : (
                            <>
                                {shortlistedCandidatesList.length === 0 ? (
                                    <div className="text-center no-jobs-message">No candidates have been shortlisted yet</div>
                                ) : (
                                    renderCandidateTable(shortlistedCandidatesList, true)
                                )}
                            </>
                        )}
                    </Col>
                </Row>
            </Container>

            <AgencyReportCandidate
                candidate={selectedCandidateForReport}
                show={showReportModal}
                onHide={() => setShowReportModal(false)}
            />
            <Footer />
        </>
    );
}

function CandidateCard({ candidate, onViewClick, onMessageClick, onReportClick, onShareClick, onShortlistClick, onCallClick, onWhatsAppClick, isShortlisted }) {
    // Helper function to format date
    const formatDate = (dateString) => {
        if (!dateString) return 'Not specified';
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    // Helper function to get languages
    const getLanguages = () => {
        if (!candidate.language || candidate.language.length === 0) {
            return 'English, Arabic';
        }
        const languages = candidate.language.map(lang => lang.language);
        if (languages.length >= 2) {
            return `${languages[0]}, ${languages[1]}`;
        }
        return languages[0];
    };

    // Helper function to get main language
    const getMainLanguage = () => {
        if (!candidate.language || candidate.language.length === 0) return 'English, Arabic';
        return `${candidate.language[0].language}`;
    };

    // Helper function to get accommodation preference
    const getAccommodationPreference = () => {
        if (!candidate.accommodation_preference || candidate.accommodation_preference === 'Not specified') {
            return 'Live in/Live Out';
        }
        return candidate.accommodation_preference;
    };

    // Helper function to get visa status
    const getVisaStatus = () => {
        if (!candidate.visa_type || candidate.visa_type === 'Not specified') {
            return 'Looking for visa';
        }
        return candidate.visa_type;
    };

    // Helper function to get available from date
    const getAvailableFrom = () => {
        const startDate = candidate.preferred_start_date;
        if (!startDate) return 'Immediate';
        if (typeof startDate === 'string' && startDate.toLowerCase().includes('immediate')) {
            return 'Immediate';
        }
        try {
            const date = new Date(startDate);
            if (!isNaN(date.getTime())) {
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            }
            return startDate;
        } catch (e) {
            return startDate || 'Immediate';
        }
    };

    const isSubscriptionActive = true;
    const isUnlocked = true;

    const handleCallAction = () => {
        if (onCallClick) onCallClick(candidate);
    };

    const handleWhatsAppClick = () => {
        if (onWhatsAppClick) onWhatsAppClick(candidate);
    };

    const handleShortlistClickLocal = () => {
        if (onShortlistClick) onShortlistClick(candidate);
    };

    const handleShareClickLocal = () => {
        if (onShareClick) onShareClick(candidate);
    };

    // Helper: format salary with currency
    const getSalary = () => {
        const usdAmount = candidate.expected_monthly_salary_usd
            ? parseFloat(candidate.expected_monthly_salary_usd)
            : 0;
        const localAmount = candidate.expected_monthly_salary
            ? parseFloat(candidate.expected_monthly_salary)
            : 0;
        const qarAmount = candidate.expected_monthly_salary_qar
            ? parseFloat(candidate.expected_monthly_salary_qar)
            : 0;

        if (usdAmount === 0 && localAmount === 0) return "Negotiable";

        let currencyCode = "";
        if (candidate.expected_monthly_salary_currency) {
            const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
            currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
        } else if (candidate.nationality) {
            const currencyMap = {
                "India": "INR", "Philippines": "PHP", "Indonesia": "IDR",
                "Sri Lanka": "LKR", "Nepal": "NPR", "Ghana": "GHS",
                "Kenya": "KES", "Uganda": "UGX", "Burundi": "BIF",
                "Vietnam": "VND", "Thailand": "THB", "Cambodia": "KHR",
                "Tanzania": "TZS", "Bangladesh": "BDT", "Ethiopia": "ETB",
                "Sierra Leone": "SLL"
            };
            currencyCode = currencyMap[candidate.nationality] || "Local";
        } else {
            currencyCode = "Local";
        }

        if (usdAmount > 0 && localAmount > 0) {
            return `${qarAmount} QAR / ${usdAmount} USD`;
        } else if (usdAmount > 0) {
            return `${usdAmount} USD`;
        } else if (localAmount > 0) {
            return `${localAmount} ${currencyCode}`;
        }
        return "Negotiable";
    };

    return (
        <Card className="h-100 shadow-sm rounded card-body-home-allcandidate">
            <Card.Body className="d-flex flex-column justify-content-between">
                <div className="d-flex">
                    <div className="me-3 text-center" style={{ marginTop: '15px' }}>
                        <div className="d-flex justify-content-center gap-2 mt-2">
                            {Number(candidate.purchased_badge) === 1 && (
                                <div className="custom-label verified-label">
                                    <span className="verified-label-icon">&#10003;</span>
                                    <span>Verified</span>
                                </div>
                            )}

                            {candidate.verification_status?.toLowerCase() !== "verified" &&
                                candidate.created_at &&
                                moment().diff(moment(candidate.created_at), "days") <= 7 && (
                                    <div className="custom-label" style={{ width: "50%" }}>
                                        New
                                    </div>
                                )}
                        </div>

                        <div className="profile-img-container">
                            {hasVisibleOfferBadge(candidate) && (
                                <div className="allcandidates-offer-badge">{getVisibleOfferBadgeText(candidate)}</div>
                            )}

                            {candidate.profile_photo ? (
                                <Image
                                    src={candidate.profile_photo}
                                    alt="profile"
                                    roundedCircle
                                    className="border allcandidate-profile-photo"
                                />
                            ) : (
                                <div
                                    className="border allcandidate-profile-photo d-flex align-items-center justify-content-center bg-light rounded-circle"
                                    style={{ width: '90px', height: '90px' }}
                                >
                                    <i className="bi bi-person-fill text-muted" style={{ fontSize: '2.5rem' }}></i>
                                </div>
                            )}
                        </div>

                        <div className="very-active-label" style={{ color: hasHighlightedSourceLabel(candidate) ? 'green' : '#111', fontWeight: hasHighlightedSourceLabel(candidate) ? '500' : 'normal' }}>
                            {getVisibleSourceLabel(candidate)}
                        </div>
                    </div>

                    <div className="flex-grow-1 allcandidate-card-right">
                        {Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("nurse")) ? (
                            <>
                                <h6 className="fw-bold candidate-heading">
                                    <span style={{ fontWeight: 500 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>
                                <ul className="small ps-3 mb-0 custom-list-candidate-agency agencycandidate-nurse-details">
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {getSalary()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("doctor")) ? (
                            <>
                                <h6 className="fw-bold candidate-heading">
                                    <span style={{ fontWeight: 500 }}>
                                        Dr.{candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>
                                <ul className="small ps-3 mb-0 custom-list-candidate-agency agencycandidate-doctor-details">
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {getSalary()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("driver")) ? (
                            <>
                                <h6 className="fw-bold candidate-heading">
                                    <span style={{ fontWeight: 500 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>
                                <ul className="small ps-3 mb-0 custom-list-candidate-agency agencycandidate-driver-details">
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {getSalary()}
                                    </li>
                                    <li>
                                        <strong>License - </strong>{' '}
                                        <span>
                                            {candidate.driving_license_country
                                                ? (() => {
                                                    try {
                                                        let licenseData = candidate.driving_license_country;
                                                        if (typeof licenseData === 'string' &&
                                                            (licenseData.startsWith('[') || licenseData.startsWith('"'))) {
                                                            licenseData = JSON.parse(licenseData);
                                                        }
                                                        if (Array.isArray(licenseData)) {
                                                            const processedLicenses = licenseData.map(license => {
                                                                if (typeof license === 'string') {
                                                                    const parts = license.split('–').map(part => part.trim());
                                                                    return parts[0];
                                                                }
                                                                return license;
                                                            });
                                                            return processedLicenses.join(', ');
                                                        }
                                                        if (typeof licenseData === 'string') {
                                                            const parts = licenseData.split('–').map(part => part.trim());
                                                            return parts[0];
                                                        }
                                                        return licenseData || 'Not specified';
                                                    } catch (e) {
                                                        const licenseStr = String(candidate.driving_license_country);
                                                        const parts = licenseStr.split('–').map(part => part.trim());
                                                        return parts[0];
                                                    }
                                                })()
                                                : 'Not specified'
                                            }
                                        </span>
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : (
                            <>
                                <h6 className="fw-bold candidate-heading">
                                    <span style={{ fontWeight: 650 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>
                                <ul className="small ps-3 mb-0 custom-list-candidate-agency agencycandidate-normal-details">
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {getSalary()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        )}
                    </div>
                </div>

                                {/* Buttons */}
                <Row className="mt-1">
                    <Col xs={3} className="px-1">
                        <Button
                            variant="light"
                            className="w-100 small-btn action-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                const user = JSON.parse(localStorage.getItem("user")) || {};
                                if (!user || (user.role !== 'agency' && user.role !== 'agency_admin')) {
                                    import('sweetalert2').then(Swal => {
                                        Swal.default.fire('Access Denied', 'Video Call feature is only available to Agencies.', 'error');
                                    });
                                } else if (user.plan_name === 'Free' || user.plan_name === 'Free Plan (Contact)') {
                                    import('sweetalert2').then(Swal => {
                                        Swal.default.fire({
                                            icon: 'error',
                                            title: 'Upgrade Required',
                                            text: 'Video Call feature is available for exclusive plans. Please upgrade.',
                                            confirmButtonText: 'Upgrade Now'
                                        }).then((result) => {
                                            if (result.isConfirmed) window.location.href = '/subscription';
                                        });
                                    });
                                } else {
                                    window.dispatchEvent(new CustomEvent('initiate-video-call', { 
                                        detail: { 
                                            candidateId: candidate?.user_id || candidate?.id, 
                                            candidateName: candidate?.first_name 
                                        } 
                                    }));
                                }
                            }}
                        >
                            <FaVideo className="text-primary" />
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="secondary" style={{ backgroundColor: '#7177a6' }}
                            className={`w-100 small-btn action-button gap-2 ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                            onClick={handleCallAction}
                        >
                            <FaPhoneAlt /> Call
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button variant="allcandidates-veiwbutton" className="w-100 small-btn action-button gap-2 allcandidates-veiwbutton" onClick={onViewClick}>
                            <FaEye /> View
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="success"
                            className={`w-100 small-btn action-button ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                            onClick={handleWhatsAppClick}
                        >
                            <i className="bi bi-whatsapp" />
                        </Button>
                    </Col>
                </Row>

                                <Row className="mt-1 text-center text-muted small fw-medium border-top pt-2 last-buttons-row">
                    <Col
                        className={`cursor-pointer no-underline ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                        onClick={handleShortlistClickLocal}
                    >
                        {isShortlisted ? (
                            <FaHeart className="text-danger me-1" />
                        ) : (
                            <FaRegHeart className="me-1" />
                        )}
                        Like
                    </Col>
                    <Col
                        className={`cursor-pointer no-underline ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                        onClick={handleShareClickLocal}
                    >
                        <i className="bi bi-share me-1"></i> Share
                    </Col>
                    <Col className="cursor-pointer no-underline" onClick={onMessageClick}>
                        <i className="bi bi-chat-dots me-1"></i> Message
                    </Col>
                    <Col className="cursor-pointer no-underline" onClick={onReportClick}>
                        <i className="bi bi-flag me-1"></i> Report
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default AgencyAppliedCandidates;
